module.exports = __webpack_public_path__ + "img/1528969199.459c30db.jpg";